import api from "./api";
import {mapHolidayDto} from "../dto/HolidayDTO";


export const getHolidayEntries = async ({role, userId}) => {
    try {
        const url = `/Holiday/user/${userId}`;
        const res =
            (role === 'admin' || role === 'super_admin')
                ? await api.get('/Holiday')
                : await api.get(url);
        return res.data.map(mapHolidayDto);
    } catch (err) {
        console.error("Error getting holiday:", err);
        throw err;
    }
};

export const createHoliday = async ({user_id, start_date, end_date, number_days}) => {
    try {
        const res = await api.post('/Holiday', {user_id, start_date, end_date, number_days});
        return res.data;
    } catch (err) {
        console.error("Error creating Holiday:", err);
        throw err;
    }
}

export const updateHoliday = async (id, {user_id, start_date, end_date, number_days}) => {
    try {
        const res = await api.patch(`/Holiday/${id}`, {user_id, start_date, end_date, number_days});
        return res.data;
    } catch (err) {
        console.error("Error updating Holiday:", err);
        throw err;
    }
}

export const deleteHoliday = async (id) => {
    try {
        const res = await api.delete(`/Holiday/${id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting Holiday:", err);
        throw err;
    }
}

export const approveHoliday = async (id) => {
    try {
        const res = await api.post(`/Holiday/${id}/approve`);
        return res.data;
    } catch (err) {
        console.error("Error approving Holiday:", err);
        throw err;
    }
}

export const rejectHoliday = async (id, reason = null) => {
    try {
        const res = await api.post(`/Holiday/${id}/reject`, { reason });
        return res.data;
    } catch (err) {
        console.error("Error rejecting Holiday:", err);
        throw err;
    }
}

export const getPendingHolidayCount = async () => {
    try {
        const res = await api.get('/Holiday/pending-count');
        return res.data?.count ?? 0;
    } catch {
        return 0;
    }
}
